<template>
	<!-- 判断 -->
	<div class="p_m_t_30">
		<div class="p_flex">
			<div class="xuan type_size_22">题目内容</div>
			<div class="choice_input p_m_l_30">
				<question-wangeditor
					ref="childs"
					v-model="topicContent.title"
					:name="topic"
					:option="1"
					:height="120"
					:width="840"
					:val="topicVal"
				></question-wangeditor>
			</div>
		</div>
		<div class="p_flex p_m_t_30">
			<div class="xuan p_flex p_f_e type_size_22">答案</div>
			<div class="choice_input p_m_l_30">
				<el-radio-group v-model="radio" @change="onChange">
					<el-radio :label="0">对</el-radio>
					<el-radio :label="1">错</el-radio>
				</el-radio-group>
			</div>
		</div>
	</div>
</template>

<script>
import QuestionWangeditor from './questionWangeditor.vue';
export default {
	components: {
		QuestionWangeditor
	},
	data() {
		return {
			// 题目内容
			topic: 'topic',
			topicVal: '',
			radio: 0,
			answer:'A'
		};
	},
	props: {
		topicContent: {
			type: Object
			// default() {
			// 	return this.$refs['childs'].getHtml();
			// }
		},
		clear:null
	},
	watch:{
		clear(n,o){
			if( n ){
				this.$refs.childs.sing()
			}
		}
	},
	created() {
		this.topicContent.answer = this.answer
		this.topicContent.affiliation = []
	},
	mounted() {},
	methods: {
		goContinue() {
			thta.$refs.childs.sing();
		},
		onChange(e) {
			if( e == 0 ){
				this.answer = 'A'
				this.topicContent.answer = 'A'
			}else{
				this.topicContent.answer = 'B'
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.choice_input {
	width: 840px;
}

.xuan {
	width: 88px;
}
>>> .el-radio__input.is-checked .el-radio__inner {
	border-color: #00af63;
	background: #00af63;
}
>>> .el-radio__input.is-checked + .el-radio__label {
	color: #00af63;
}
>>> .el-radio__inner {
	width: 20px;
	height: 20px;
}
>>> .el-radio__label {
	font-size: 18px;
}
>>> .el-radio__inner:hover {
	border-color: #999999;
}
>>> .el-radio__inner::after {
	width: 8px;
	height: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/singleJudge.vue